<div mat-dialog-title class="flex-row flex-align-center desktop-dialog">
	<img id="dialogLogoDN" [src]="infoLogoDn" [alt]="'logo'" />
	<div class="dialog-title" style="flex: 1; text-align: center;">{{ dialogTitle() }}</div>
	@if (!isLocking()) {
	<button mat-icon-button (click)="dismissEmailConfirm()">
		<fa-icon class="dn-icon" [icon]="getCrossIcon()"></fa-icon>
	</button>
	}
</div>
<div mat-dialog-title class="flex-row flex-align-center mobile-dialog">
	@if (!isLocking()) {
	<button mat-icon-button (click)="dismissEmailConfirm()">
		<fa-icon class="dn-icon" [icon]="getChevronLeftIcon()"></fa-icon>
	</button>
	}
	<div class="dialog-title" style="flex: 1; text-align: center;">{{ dialogTitle() }}</div>
	<img id="dialogLogoDN" [src]="infoLogoDn" [alt]="'logo'" />
</div>

<hr class="dialog-title-separator" />

<mat-dialog-content>
	<dottnet-mail-confirm
		[user]="user()"
		[emailConfirmationStatus]="emailConfirmationStatus()"
		(sendMailEvent)="sendMail()"
		(dismissEvent)="dismissEmailConfirm()"
		(submitNewEmail)="onSubmitNewEmail($event)">
	</dottnet-mail-confirm>
</mat-dialog-content>
